import * as R from 'ramda'
import { GSMCampaign, GSMCampaignGroup, ValueAddedServicesAddendum, ValueAddedServicesGroup } from './types'
import { EquipmentGroupStId, Selections } from '../../../../types/types'
import { groupLens, lensProp } from './lens-utils'

// const groupL = (groupId: EquipmentGroupStId) =>
//   new Optional<ValueAddedServicesAddendum, ValueAddedServicesGroup>(
//     s => (s.groups[groupId] ? some(s.groups[groupId]) : none),
//     a => s => new ValueAddedServicesAddendum(R.assoc(groupId, a, s.groups), s.interactionSelections)
//   )

const selectionsL = lensProp<ValueAddedServicesGroup, 'selections'>('selections')
// TODO: Remove as part of GSM Clean up
// const groupGSM = (groupId: EquipmentGroupStId) =>
//   new Optional<GSMCampaign, GSMCampaignGroup>(
//     s => (s.groups[groupId] ? some(s.groups[groupId]) : none),
//     a => s => new GSMCampaign(R.assoc(groupId, a, s.groups), s.interactionSelections)
//   )

const groupGSM = (groupId: EquipmentGroupStId) =>
  groupLens<GSMCampaign, GSMCampaignGroup, 'groups'>(
    groupId,
    'groups',
    (groups, interactionSelections) => new GSMCampaign(groups, interactionSelections),
    s => [s.interactionSelections]
  )

const selectionsGSM = lensProp<GSMCampaignGroup, 'selections'>('selections')

export function updateSelections(
  f: (xs: Selections) => Selections,
  groupId: EquipmentGroupStId,
  offering: ValueAddedServicesAddendum
): ValueAddedServicesAddendum {
  return groupL(groupId).compose(selectionsL.asOptional()).modify(f)(offering)
}
// TODO: Remove as part of GSM Clean up
export function updateGSMSelections(
  f: (xs: Selections) => Selections,
  groupId: EquipmentGroupStId,
  offering: GSMCampaign
): GSMCampaign {
  return groupGSM(groupId).compose(selectionsGSM.asOptional()).modify(f)(offering)
}

export function allSelections(
  groups: Record<EquipmentGroupStId, ValueAddedServicesGroup>
): Record<EquipmentGroupStId, Selections[]> {
  return R.map(g => [g.selections], groups)
}

export function selections(groupId: EquipmentGroupStId, offering: ValueAddedServicesAddendum) {
  return groupL(groupId).compose(selectionsL.asOptional()).getOption(offering)
}

const groupL = (groupId: EquipmentGroupStId) =>
  groupLens<ValueAddedServicesAddendum, ValueAddedServicesGroup, 'groups'>(
    groupId,
    'groups',
    (groups, interactionSelections) => new ValueAddedServicesAddendum(groups, interactionSelections),
    s => [s.interactionSelections]
  )
